import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=f6bc6a2c&scoped=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bc6a2c",
  null
  
)

export default component.exports